var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row mt-2 py-2 knockout-wrap smaller-font-content bg-white shadow-sm",
      attrs: { id: "knockout-" + _vm.carCountFail }
    },
    [
      _c("div", { staticClass: "col-3 text-center" }, [
        _c(
          "div",
          {
            staticClass: "carrierLogo",
            attrs: { id: _vm.carrier.carrier_name }
          },
          [
            _c("img", {
              attrs: {
                src: _vm.carrier.logoPathSvg,
                alt: _vm.carrier.carrier_name,
                width: "100%",
                height: "auto"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "col-9 my-auto",
        domProps: { innerHTML: _vm._s(_vm.carrier.status_message) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0c05a78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0c05a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/CarrierDetailsFailure.vue
// module id = null
// module chunks = 